import moment from 'moment'
function getWorkingHoursForDate (dayMoment, workingHours) {
  // filtrar qué working hours incluyen ese día
  var dayWorkingHours = workingHours.filter((wH) => {
    return moment(wH.startDate).startOf('day').isBefore(dayMoment) && moment(wH.endDate).endOf('day').isAfter(dayMoment)
  })
  // de esos, obtener los más cortos
  var chosenWorkingHour = null
  var currentLength = null
  dayWorkingHours.forEach(workingHour => {
    if (!currentLength) {
      currentLength = moment(workingHour.endDate).endOf('day').diff(moment(workingHour.startDate))
      chosenWorkingHour = workingHour
    } else {
      if (moment(workingHour.endDate).endOf('day').diff(moment(workingHour.startDate)) === currentLength) {
        // si hay más de uno, quedarse con el que haya empezado después
        if (moment(chosenWorkingHour.startDate).isBefore(workingHour.startDate)) {
          chosenWorkingHour = workingHour
        }
      } else if (moment(workingHour.endDate).endOf('day').diff(moment(workingHour.startDate)) < currentLength) {
        currentLength = moment(workingHour.endDate).endOf('day').diff(moment(workingHour.startDate))
        chosenWorkingHour = workingHour
      }
    }
  })
  return chosenWorkingHour
}
export {
  getWorkingHoursForDate,
}
